import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
import Form from '../../common/components/Form';

/**
 * The `ChangePasswordModal` component shows a modal dialog which allows the
 * user to send themself a password reset email.
 */
export default class ChangePasswordModal extends FormModal {
  className() {
    return 'ChangePasswordModal Modal--small';
  }
  title() {
    return app.translator.trans('core.forum.change_password.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const fields = new ItemList();
    fields.add('help', m("p", {
      className: "helpText"
    }, app.translator.trans('core.forum.change_password.text')));
    fields.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.forum.change_password.send_button'))));
    return fields;
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/forgot',
      body: this.requestBody()
    }).then(this.hide.bind(this), this.loaded.bind(this));
  }
  requestBody() {
    return {
      email: app.session.user.email()
    };
  }
}
flarum.reg.add('core', 'forum/components/ChangePasswordModal', ChangePasswordModal);